import { HttpClient } from '@angular/common/http';
import { catchError, tap } from 'rxjs/operators';
import { throwError, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { ConfigurationService } from './configuration.service';
import { SystemPrompt } from '../models/system-prompt.interface';
import { DriftConfiguration } from '../models/configuration.interface';

@Injectable({
  providedIn: 'root'
})
export class PromptService {
  config: DriftConfiguration;
  constructor(
    private http: HttpClient,
    private configurationService: ConfigurationService
  ) {
    this.config = this.configurationService.getConfiguration();
  }

  getSystemPrompts(): Observable<SystemPrompt[]> {
    return this.http.get<SystemPrompt[]>(`${this.config.driftApi}/system-prompts`).pipe(
      tap(response => console.log('API response:', response)),
      catchError(error => {
        console.error('Error fetching system prompts:', error);
        return throwError(() => new Error('Failed to fetch system prompts'));
      })
    );
  }

  updateSystemPrompt({ name, arn, prompt_type, version, prompt }: SystemPrompt): Observable<SystemPrompt[]> {
    const requestBody = {
      name,
      arn,
      prompt_type,
      version,
      prompt
    };
    return this.http.put<SystemPrompt[]>(`${this.config.driftApi}/system-prompts/${name}`, requestBody).pipe(
      tap(response => console.log('API response:', response)),
      catchError(error => {
        console.error('Error updating system prompt:', error);
        return throwError(() => new Error('Failed to update system prompt'));
      })
    );
  }
}
